interface JobCatalogLevel {
  name?: string | null
  roleName?: string | null
}
interface ReferenceContractData {
  jobTitle?: string | null
  jobCatalogLevel?: JobCatalogLevel | null
  jobCatalogRole?: string | null
}

export const getEmployeeJobRole = (referenceContract?: ReferenceContractData | null): string => {
  const jobTitle = referenceContract?.jobTitle

  if (jobTitle) {
    return jobTitle
  }

  const jobCatalogLevel = referenceContract?.jobCatalogLevel
  // Support both structures: jobCatalogLevel.roleName (old) and jobCatalogRole (new GraphQL)
  const jobRoleName = jobCatalogLevel?.roleName || referenceContract?.jobCatalogRole || ''
  const jobLevelName = jobCatalogLevel?.name || ''
  if (!jobLevelName || jobLevelName === '__default__' || jobLevelName === 'null') return jobRoleName

  return `${jobRoleName}, ${jobLevelName}`
}
